var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('topInfo',{attrs:{"isUser":_vm.showUser}}),(!_vm.showUser)?_c('topEx'):_vm._e(),_c('Affix',{staticStyle:{"background":"#fff"}},[(!_vm.showUser)?_c('topLink'):_vm._e()],1),(_vm.showUser)?_c('topUser'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }